import React, { FunctionComponent } from 'react';
import { Serie } from '@nivo/line';
import DefaultLineChart from '../default-line-chart';

type Props = {
  data: Serie[];
};

const CallsGraphView: FunctionComponent<Props> = ({ data }) => {
  return <DefaultLineChart data={data} colors={['#000DFF', '#80ccff']} />;
};

export default CallsGraphView;
